import React, { useMemo } from 'react';
import { IExtendedCustomerBPA, BpaPaymentSystem } from 'types';
import { bpaPaymentSystem } from 'appConstants';
import { ISelectOption } from 'components/Select/types';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormSelect from 'components/Select/FormSelect';

interface IProps {
	tariffId: string;
	tariffs: IExtendedCustomerBPA['tariffs'];
	onChange: (value: BpaPaymentSystem) => void;
}

export const BpaPaymentSystemSelect: React.FC<IProps> = ({ tariffId, tariffs, onChange }) => {
	const { t } = useTranslation('error');
	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectTypeOfCard') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(
		() =>
			bpaPaymentSystem.map((el) => {
				const reservedTariffs = tariffs
					.filter((tariff) => tariff.id !== tariffId)
					.map((tariff) => tariff.typeOfBpaPaymentSystem);

				return {
					id: el.id,
					name: el.name,
					disabled: reservedTariffs.includes(el.id),
				};
			}),
		[tariffId, tariffs],
	);

	return (
		<FormSelect
			testId="BpaPaymentSystemSelect"
			name={`typeOfBpaPaymentSystem-${tariffId}`}
			label="typeOfCardLabel"
			options={mappedOptions}
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};
